import BottomSheet from '~/app/components/common/BottomSheet/BottomSheet'
import styled from '~/app/components/styled'
import { useMemo, useRef } from 'react'
import { PropertyCategory } from '~/__generated__/__types__'
import { Typography } from '@yanolja-org/ya-com-core'

const Container = styled.section`
  padding: 0 2rem;
  width: 100%;
`

const Notice = styled.p`
  padding: 1.2rem 2rem;
  border-radius: 0.4rem;
  border: solid 0.1rem ${({ theme }) => theme.color.yaorange200};
  background-color: ${({ theme }) => theme.color.yaorange50};

  ${Typography('body2.multiline').bold};
  color: ${({ theme }) => theme.color.yaorange};
`

const SubTitle = styled.h3`
  ${Typography('subtitle2').bold};
  margin: 2.8rem 0 1.2rem;
`

const Table = styled.table`
  width: 100%;

  tr {
    ${Typography('body2').regular};
    color: ${({ theme }) => theme.color.gray600};
  }

  tr:first-of-type {
    background: ${({ theme }) => theme.color.gray50};
    color: ${({ theme }) => theme.color.gray900};
    ${Typography('body2').bold};
  }

  td {
    width: 50%;
    border: 0.1rem solid ${({ theme }) => theme.color.gray200};
    padding: 0.8rem 1.2rem;
  }
`

const Caution = styled.div`
  ${Typography('body1').regular};
  margin-top: 1.2rem;
  color: ${({ theme }) => theme.color.gray600};
`

export default function ExceptionalFreeBottomSheet({ isOpened, onRequestClose, propertyCategory }) {
  const HotelPensionGuestHouseTableInfo = useRef([
    ['상황', '무료 취소 가능 시간'],
    ['예약 완료 후, 체크인 시간까지 10분 이상 남은 경우', '예약 완료 시점부터 10분 이내'],
    ['예약 완료 후, 체크인 시간까지 10분 미만 남은 경우', '체크인 시간 전까지'],
    ['체크인 시간 이후 예약 완료한 경우', '무료취소 불가'],
  ]).current

  const MotelTableInfo = useRef([
    ['상황', '무료 취소 가능 시간'],
    ['예약 완료 후, 체크인 시간까지 1시간 이상 남은 경우', '예약 완료 시점부터 1시간 이내'],
    ['예약 완료 후, 체크인 시간까지 1시간 미만 남은 경우', '체크인 시간 전까지'],
    [
      '체크인 시간 이후 예약 완료한 경우',
      '예약 완료 시점부터 15분 이내 (단, 체크인 시 무료 취소 불가)',
    ],
  ]).current

  const isMotel = useMemo(() => propertyCategory === PropertyCategory.Motel, [propertyCategory])

  return (
    <BottomSheet isOpened={isOpened} onRequestClose={onRequestClose} title={'무료 취소 안내'}>
      <Container>
        <Notice>
          취소 및 환불이 불가한 숙소 상품을 예약한 경우도 예약 완료 후 일정 시간 이내에 무료로
          취소할 수 있습니다.
        </Notice>
        {isMotel ? (
          <>
            <SubTitle>모텔</SubTitle>
            <Table>
              <tbody>
                {MotelTableInfo.map(([situation, availableTime], idx) => (
                  <tr key={idx}>
                    <td>{situation}</td>
                    <td>{availableTime}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          <>
            <SubTitle>호텔/펜션/게스트하우스</SubTitle>
            <Table>
              <tbody>
                {HotelPensionGuestHouseTableInfo.map(([situation, availableTime], idx) => (
                  <tr key={idx}>
                    <td>{situation}</td>
                    <td>{availableTime}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Caution>단, 일부 호텔의 경우 숙소 정책에 따라 무료 취소가 불가합니다.</Caution>
          </>
        )}
      </Container>
    </BottomSheet>
  )
}
